export enum OverlayPosition {
	Fill = "FILL",
	Bottom = "BOTTOM"
}